import { createFileRoute } from "@tanstack/react-router";
import { VisitCallPage } from "@/components/app/visits/visit-call-page";

export const Route = createFileRoute("/family-portal/visits/$visitId")({
  head: () => ({ meta: [{ title: "Video visit | People AI" }] }),
  component: FamilyVisitCall,
});

function FamilyVisitCall() {
  const { visitId } = Route.useParams();
  return <VisitCallPage kind="family" visitId={visitId} />;
}
